// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.faq-section {
  margin: 0 auto;
  width: 70%;
  color: #191919;
  padding-bottom: 40px;
}
.faq-section .toggle-header {
  font-size: 20px;
}
.faq-section .acc-content {
  font-size: 14px;
}
.faq-section .acc-content p {
  padding-left: 3%;
  padding-right: 6%;
}
.faq-section h1 {
  font-size: 38px;
}
.faq-section h2 {
  padding-bottom: 0px;
  font-size: 30px;
}
.faq-section .tab-content-faq {
  left: 0;
  /* position: absolute; */
  top: 70px;
  width: 100%;
}
.faq-section .tab-content-faq ul {
  margin: 12px 0 20px 62px;
}
.faq-section .tab-content-faq ul li {
  line-height: 20px;
  padding-left: 15px;
  position: relative;
  text-align: left;
  width: 90%;
}
.faq-section .tab-content-faq ul li::after {
  background-color: #333333;
  border: 2px solid #333333;
  border-radius: 100%;
  content: "";
  display: block;
  height: 1px;
  left: 0;
  position: absolute;
  top: 8px;
  width: 1px;
}
.faq-section .tab-content-faq ol {
  margin: 12px 0 20px 62px;
}
.faq-section .tab-content-faq ol li {
  list-style-type: decimal;
  line-height: 20px;
  padding-left: 15px;
  position: relative;
  text-align: left;
  width: 90%;
}

@media (max-width: 1024px) {
  .faq-section {
    padding-left: 1%;
    margin: 5px auto;
    color: #191919;
    margin-top: 65px;
  }
  .faq-section .accheader {
    padding: 0 !important;
  }
  .faq-section .acc-content {
    font-size: 14px;
  }
  .faq-section .acc-content p {
    padding-left: 3%;
    padding-right: 6%;
  }
  .faq-section h1 {
    padding-bottom: 0px !important;
    line-height: 35px;
  }
  .faq-section h2 {
    padding-top: 0px !important;
    line-height: 35px;
  }
  .faq-section .tab-content-faq {
    left: 0;
    padding: 0 15px;
    /* position: absolute; */
    top: 70px;
    width: 100%;
  }
  .faq-section .tab-content-faq ul {
    margin: 12px 0 20px 20px;
  }
  .faq-section .tab-content-faq ul li {
    line-height: 20px;
    padding-left: 15px;
    position: relative;
    text-align: left;
  }
  .faq-section .tab-content-faq ul li::after {
    background-color: #333333;
    border: 2px solid #333333;
    border-radius: 100%;
    content: "";
    display: block;
    height: 1px;
    left: 0;
    position: absolute;
    top: 8px;
    width: 1px;
  }
  .faq-section .tab-content-faq ol {
    margin: 12px 0 20px 20px;
  }
  .faq-section .tab-content-faq ol li {
    list-style-type: decimal;
    line-height: 20px;
    padding-left: 15px;
    position: relative;
    text-align: left;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/faq/faq.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAhJA;EACE,cAAA;EACA,UAAA;EACA,cAAA;EACA,oBAAA;AAkJF;AAjJE;EAEE,eAAA;AAkJJ;AA/IE;EACI,eAAA;AAiJN;AAhJE;EACE,gBAAA;EACA,iBAAA;AAkJJ;AA/IA;EACG,eAAA;AAiJH;AA/IM;EACI,mBAAA;EACA,eAAA;AAiJV;AA/IK;EACG,OAAA;EAGA,wBAAA;EACA,SAAA;EACA,WAAA;AA+IR;AA7IQ;EACI,wBAAA;AA+IZ;AA9IY;EACI,iBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AA+IhB;AA7IY;EACI,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AA+IhB;AA5IQ;EACI,wBAAA;AA8IZ;AA7IY;EACI,wBAAA;EACA,iBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AA8IhB;;AFzLI;EEkDF;IACE,gBAAA;IACA,gBAAA;IAEA,cAAA;IACD,gBAAA;EA0ID;EAtIE;IACM,qBAAA;EAwIR;EAtII;IACE,eAAA;EAwIN;EAvIM;IACE,gBAAA;IACA,iBAAA;EAyIR;EAtIE;IACI,8BAAA;IACA,iBAAA;EAwIN;EAtIE;IACI,2BAAA;IACA,iBAAA;EAwIN;EAtIK;IACC,OAAA;IACA,eAAA;IAEA,wBAAA;IACA,SAAA;IACA,WAAA;EAuIN;EArIM;IACI,wBAAA;EAuIV;EArIU;IACI,iBAAA;IACA,kBAAA;IACA,kBAAA;IACA,gBAAA;EAuId;EApIU;IACI,yBAAA;IACA,yBAAA;IACA,mBAAA;IACA,WAAA;IACA,cAAA;IACA,WAAA;IACA,OAAA;IACA,kBAAA;IACA,QAAA;IACA,UAAA;EAsId;EAnIM;IACI,wBAAA;EAqIV;EAnIU;IACI,wBAAA;IACA,iBAAA;IACA,kBAAA;IACA,kBAAA;IACA,gBAAA;EAqId;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import  '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n;\n\n.faq-section {\n  margin: 0 auto;\n  width: 70%;\n  color:#191919;\n  padding-bottom: 40px;\n  .toggle-header{\n    // border-top: 1px solid #959595;\n    font-size: 20px;\n\n  }\n  .acc-content{\n      font-size: 14px;\n  p{\n    padding-left: 3%;\n    padding-right: 6%;\n  }\n}\nh1{\n   font-size: 38px; \n}\n      h2{\n          padding-bottom: 0px;\n          font-size: 30px;\n      }\n     .tab-content-faq{\n        left: 0;\n        // padding:0 15px;\n\n        /* position: absolute; */\n        top: 70px;\n        width: 100%;\n\n        ul{\n            margin: 12px 0 20px 62px;\n            li {\n                line-height: 20px;\n                // margin-top: 12px;\n                padding-left: 15px;\n                position: relative;\n                text-align: left;\n                width: 90%\n            }\n            li::after{\n                background-color: #333333;\n                border: 2px solid #333333;\n                border-radius: 100%;\n                content: '';\n                display: block;\n                height: 1px;\n                left: 0;\n                position: absolute;\n                top: 8px;\n                width: 1px;\n            }\n        }\n        ol {\n            margin: 12px 0 20px 62px;\n            li {\n                list-style-type: decimal;\n                line-height: 20px;\n                // margin-top: 12px;\n                padding-left: 15px;\n                position: relative;\n                text-align: left;\n                width: 90%\n            } \n        }\n    }\n}\n@include respond-to (small) {\n\n  .faq-section {\n    padding-left:1%;\n    margin: 5px auto;\n    // width: 95%;\n    color:#191919;\n   margin-top: 65px;\n    .toggle-header{\n        // border-top: 1px solid #959595;\n      }\n    .accheader{\n          padding:0 !important;\n      }\n      .acc-content{\n        font-size:14px;\n        p{\n          padding-left: 3%;\n          padding-right: 6%;\n        }\n    }\n    h1{           \n        padding-bottom: 0px !important;\n        line-height: 35px;\n    }\n    h2{           \n        padding-top: 0px !important;\n        line-height: 35px;\n    }\n       .tab-content-faq{\n        left: 0;\n        padding:0 15px;\n\n        /* position: absolute; */\n        top: 70px;\n        width: 100%;\n       \n        ul{\n            margin: 12px 0 20px 20px;\n\n            li {\n                line-height: 20px;\n                padding-left: 15px;\n                position: relative;\n                text-align: left;\n            }\n\n            li::after{\n                background-color: #333333;\n                border: 2px solid #333333;\n                border-radius: 100%;\n                content: '';\n                display: block;\n                height: 1px;\n                left: 0;\n                position: absolute;\n                top: 8px;\n                width: 1px;\n            }\n        }\n        ol {\n            margin: 12px 0 20px 20px;\n           \n            li {\n                list-style-type: decimal;\n                line-height: 20px;\n                padding-left: 15px;\n                position: relative;\n                text-align: left; \n            }\n        }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
